module.exports = __webpack_public_path__ + "img/userLogo3.dae78629.jpg";